<template>
	<v-sheet>
        <MwList storeModule="emailTemplates" :columns="headers">
        </MwList>
    </v-sheet>
</template>

<script type="text/javascript">
import MwList from "@c/ui/MwList";
export default {
	name: "EmailTemplates",
    data: () => {
        return {
            filtered: false
        }
    },
	computed: {
		headers() {
			return [
				{value: "subject", text: "Subhect", default: true},
			];
		},
	},
	components: {
		MwList
	},
};
//
</script>
"
